<template>
  <div id="publication-dashboard--schedules">
    <h3 is="sui-header">
      <i class="calendar alternate outline icon"></i>
      {{ $t('Schedules') }}
    </h3>
    <sui-divider />
    <div class="stackable one column grid ui schedule-container">
      <div class="column" v-for="(schedule, index) in schedulesData" :key="index">
        <div class="schedule">
          <h4 is="sui-header">{{ schedule.name }}</h4>
          <sui-divider />
          <vue-calendar
            height="300px"
            :highlight="highlightedDays"
          ></vue-calendar>
        </div>
      </div>
    </div>
    <sui-dimmer :active="loading" inverted>
      <sui-loader />
    </sui-dimmer>
  </div>
</template>

<script>

import { rrulestr } from 'rrule';
import forEach from 'lodash/forEach';

export default {
  name: 'schedules',
  props: ['dataRequested', 'schedulesData'],
  watch: {
    schedules() {
      this.setHighlightedDays();
    }
  },
  updated() {
    this.removeLoader();
    this.modifyNavigationArrows();
    this.setHighlightedDays();
  },
  mounted() {
    this.removeLoader();
    this.modifyNavigationArrows();
    this.setHighlightedDays();
  },
  methods: {
    setHighlightedDays() {
      forEach(this.schedulesData, (v, k) => {
        let rule = rrulestr(v.recurrence);
        let thisDate = new Date();
        let now = new Date(Date.UTC(
          thisDate.getUTCFullYear(),
          thisDate.getUTCMonth(),
          thisDate.getUTCDate()
        ));
        let yearsInAdvance = new Date(Date.UTC(now.getUTCFullYear() + this.years));
        this.highlightedDays.dates = rule.between(now, yearsInAdvance);
      });
    },
    // The `vue2-simple-calendar` package does not have
    // options for styling the navigation arrows
    modifyNavigationArrows() {
      let leftArrow = '<i class="angle left icon"></i>';
      let rightArrow = '<i class="angle right icon"></i>';
      let arrows = document.querySelectorAll('.prev-month, .next-month');
      forEach(arrows, function (v, k) {
        if (v.className === 'prev-month') {
          v.innerHTML = leftArrow;
        } else if (v.className === 'next-month') {
          v.innerHTML = rightArrow;
        }
      });
    },
    removeLoader() {
      if (this.dataRequested) {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      loading: true,
      years: 5,
      highlightedDays: {
        dates: []
      }
    };
  },
};
</script>

<style lang="scss">
.vue-calendar {
  display: grid;
  grid-template-rows: 10% 90%;
  background: #fff;
  margin: 0 auto;
  .calendar-header {
    align-items: center;
    .header-left,
    .header-right {
      flex: 1;
    }
    .header-center {
      display: flex;
      text-align: center;
      .title {
        margin: 0 5px;
        flex-grow: 1;
      }
      .next-month,
      .prev-month {
        cursor: pointer;
        font-size: 2rem;
      }
    }
  }
  .calendar-body {
    display: grid;
    grid-template-rows: 10% 90%;
    .days-header {
      display: grid;
      grid-auto-columns: 14.25%;
      grid-template-areas: "a a a a a a a";
      .day-label {
        text-align: center;
      }
    }
    .days-body {
      display: grid;
      grid-template-rows: auto;
      .week-row {
        display: grid;
        grid-template-areas: "a a a a a a a";
        grid-row-gap: 5px;
        grid-auto-columns: 14.25%;
        .week-day {
          margin: 2px;
          padding: 5px;
          border-radius: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
          .day-number {
            text-align: center;
            width: 100%;
          }
          &.today {
            .day-number {
              font-weight: 700;
              position: relative;
              &:after {
                position: absolute;
                content: '';
                bottom: -5px;
                left: 0;
                right: 0;
                height: 3px;
                background-color: #de348b;
              }
            }
            &.highlighted {
              .day-number:after {
                background-color: #fff;
              }
            }
          }
          &.highlighted {
            background-color: #242e59;
            .day-number {
              color: #fff;
            }
          }
          &.disabled {
            background-color: #f5f5f5;
          }
          &.not-current {
            &.highlighted {
              background-color: #383f5f;
            }
            > .day-number {
              color: #a5a5a5;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
#publication-dashboard--schedules {
  .schedule-container {
    .column .schedule {
      border-bottom: 1px solid #dededf;
      padding-bottom: 1rem;
    }
    .column:last-of-type .schedule {
      border: none;
      margin-bottom: initial;
      padding-bottom: 0;
    }
  }
}
</style>
